{
  "version": 1,
  "asset_id": "5d0ad13c-f91b-47a4-9c6f-e5ce6f80840c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5d0ad13c-f91b-47a4-9c6f-e5ce6f80840c/bypass-revision-resection-es.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5d0ad13c-f91b-47a4-9c6f-e5ce6f80840c/bypass-revision-resection-es.png",
  "original_filename": "bypass-revision-resection-es.png",
  "size": 1350386,
  "content_type": "image/png",
  "created_at": "2026-10-05T22:41:34Z"
}
